import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isAppointmentReminderNotificationDetails } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function(notification: Notification): NotificationData | false {
  if (isAppointmentReminderNotificationDetails(notification.details)) {
    emitter.emit(EVENTS.UPCOMING_APPOINTMENT_REMINDER, notification);
  }
  return false;
}
